// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
  .nightbot-button-module__button-FTSYP .nightbot-button-module__buttonInner-CNbjx {
    gap: 4px;
  }

.nightbot-button-module__button-FTSYP .nightbot-button-module__buttonLoader-MxCrP,.nightbot-button-module__button-FTSYP .nightbot-button-module__buttonInner-CNbjx {
    /* important as transition styling is applied inline */
    transition: none !important;
  }

.nightbot-button-module__button-FTSYP:active {
    transform: none;
    transform: initial;
    box-shadow: var(--mantine-shadow-outline);
  }

.nightbot-button-module__button-FTSYP[data-variant='link'] {
    height: -moz-fit-content;
    height: fit-content;
    background-color: transparent;
    color: var(--text-link);
    padding: 0px;
    border-radius: 0;
    border-radius: initial;
  }

.nightbot-button-module__button-FTSYP[data-variant='link']:active {
      box-shadow: none;
      box-shadow: initial;
    }

.nightbot-button-module__button-FTSYP[data-variant='link'] .nightbot-button-module__buttonInner-CNbjx:hover {
        -webkit-text-decoration: underline;
        text-decoration: underline;
        text-decoration-color: currentColor;
      }

.nightbot-button-module__button-FTSYP[data-variant='light'] {
    border-width: 1px;
    border-color: var(--button-hover);
  }

.nightbot-button-module__button-FTSYP[data-variant='transparent']:hover {
      background-color: var(--background-hover);
    }

.nightbot-button-module__button-FTSYP[data-variant='transparent']:active {
      box-shadow: none;
      box-shadow: initial;
    }

.nightbot-button-module__button-FTSYP[data-variant='active'] {
    background-color: var(--background-accent);
  }

.nightbot-button-module__button-FTSYP[data-variant='active'] .nightbot-button-module__buttonInner-CNbjx {
      color: var(--text-active);
      --button-color: var(--text-active);
    }

.nightbot-button-module__button-FTSYP[data-variant='active']:active {
      background-color: var(--background-accent-secondary);
      box-shadow: none;
      box-shadow: initial;
    }

[data-mantine-color-scheme='light']:root .nightbot-button-module__button-FTSYP[data-variant='inverse'] {
      --button-color: var(--mantine-color-gray-1);
      color: var(--mantine-color-gray-1);
      background-color: var(--mantine-color-gray-9);
    }

[data-mantine-color-scheme='light']:root .nightbot-button-module__button-FTSYP[data-variant='inverse']:disabled {
        background-color: var(--mantine-color-gray-5);
        --button-color: var(--mantine-color-gray-1);
        color: var(--mantine-color-gray-1);
        box-shadow: none;
        box-shadow: initial;
      }

[data-mantine-color-scheme='light']:root .nightbot-button-module__button-FTSYP[data-variant='inverse'][data-loading] {
        --button-color: var(--mantine-color-gray-1);
        color: var(--mantine-color-gray-1);
        background-color: var(--mantine-color-gray-9);
      }

[data-mantine-color-scheme='light']:root .nightbot-button-module__button-FTSYP[data-variant='normal'] {
      --button-color: var(--text-primary);
      color: var(--text-primary);
      background-color: var(--mantine-color-gray-0);
      border-width: 1px;
      border-color: var(--border-secondary);
    }

[data-mantine-color-scheme='light']:root .nightbot-button-module__button-FTSYP[data-variant='normal']:disabled {
        box-shadow: none;
        box-shadow: initial;
        --button-color: var(--text-tertiary);
        color: var(--text-tertiary);
      }

[data-mantine-color-scheme='light']:root .nightbot-button-module__button-FTSYP[data-variant='normal']:hover {
        background-color: var(--mantine-color-gray-1);
      }

[data-mantine-color-scheme='dark']:root .nightbot-button-module__button-FTSYP[data-variant='inverse'] {
      --button-color: var(--mantine-color-gray-9);
      color: var(--mantine-color-gray-9);
      background-color: var(--mantine-color-gray-1);
    }

[data-mantine-color-scheme='dark']:root .nightbot-button-module__button-FTSYP[data-variant='inverse']:disabled {
        background-color: var(--mantine-color-gray-6);
        --button-color: var(--mantine-color-gray-9);
        color: var(--mantine-color-gray-9);
        box-shadow: none;
        box-shadow: initial;
      }

[data-mantine-color-scheme='dark']:root .nightbot-button-module__button-FTSYP[data-variant='inverse'][data-loading] {
        --button-color: var(--mantine-color-gray-9);
        color: var(--mantine-color-gray-9);
        background-color: var(--mantine-color-gray-1);
      }

[data-mantine-color-scheme='dark']:root .nightbot-button-module__button-FTSYP[data-variant='normal'] {
      --button-color: var(--text-primary);
      color: var(--text-primary);
      background-color: var(--mantine-color-gray-9);
      border-width: 1px;
      border-color: var(--border-secondary);
    }

[data-mantine-color-scheme='dark']:root .nightbot-button-module__button-FTSYP[data-variant='normal']:disabled {
        box-shadow: none;
        box-shadow: initial;
        --button-color: var(--text-tertiary);
        color: var(--text-tertiary);
      }

[data-mantine-color-scheme='dark']:root .nightbot-button-module__button-FTSYP[data-variant='normal']:hover {
        background-color: var(--background-hover);
      }
`, "",{"version":3,"sources":["webpack://./src/utils/theme/button.module.scss"],"names":[],"mappings":";EACE;IACE,QAAQ;EACV;;AAEA;IAEE,sDAAsD;IACtD,2BAA2B;EAC7B;;AAEA;IACE,eAAgB;IAAhB,kBAAgB;IAChB,yCAAyC;EAC3C;;AAEA;IACE,wBAAmB;IAAnB,mBAAmB;IACnB,6BAA6B;IAC7B,uBAAuB;IACvB,YAAY;IACZ,gBAAoB;IAApB,sBAAoB;EAYtB;;AAVE;MACE,gBAAiB;MAAjB,mBAAiB;IACnB;;AAGE;QACE,kCAA0B;QAA1B,0BAA0B;QAC1B,mCAAmC;MACrC;;AAIJ;IACE,iBAAiB;IACjB,iCAAiC;EACnC;;AAGE;MACE,yCAAyC;IAC3C;;AAEA;MACE,gBAAiB;MAAjB,mBAAiB;IACnB;;AAGF;IACE,0CAA0C;EAW5C;;AATE;MACE,yBAAyB;MACzB,kCAAkC;IACpC;;AAEA;MACE,oDAAoD;MACpD,gBAAiB;MAAjB,mBAAiB;IACnB;;AAMA;MACE,2CAA2C;MAC3C,kCAAkC;MAClC,6CAA6C;IAc/C;;AAZE;QACE,6CAA6C;QAC7C,2CAA2C;QAC3C,kCAAkC;QAClC,gBAAiB;QAAjB,mBAAiB;MACnB;;AAEA;QACE,2CAA2C;QAC3C,kCAAkC;QAClC,6CAA6C;MAC/C;;AAGF;MACE,mCAAmC;MACnC,0BAA0B;MAC1B,6CAA6C;MAC7C,iBAAiB;MACjB,qCAAqC;IAWvC;;AATE;QACE,gBAAiB;QAAjB,mBAAiB;QACjB,oCAAoC;QACpC,2BAA2B;MAC7B;;AAEA;QACE,6CAA6C;MAC/C;;AAOF;MACE,2CAA2C;MAC3C,kCAAkC;MAClC,6CAA6C;IAc/C;;AAZE;QACE,6CAA6C;QAC7C,2CAA2C;QAC3C,kCAAkC;QAClC,gBAAiB;QAAjB,mBAAiB;MACnB;;AAEA;QACE,2CAA2C;QAC3C,kCAAkC;QAClC,6CAA6C;MAC/C;;AAGF;MACE,mCAAmC;MACnC,0BAA0B;MAC1B,6CAA6C;MAC7C,iBAAiB;MACjB,qCAAqC;IAWvC;;AATE;QACE,gBAAiB;QAAjB,mBAAiB;QACjB,oCAAoC;QACpC,2BAA2B;MAC7B;;AAEA;QACE,yCAAyC;MAC3C","sourcesContent":[".button {\n  .buttonInner {\n    gap: 4px;\n  }\n\n  .buttonLoader,\n  .buttonInner {\n    /* important as transition styling is applied inline */\n    transition: none !important;\n  }\n\n  &:active {\n    transform: unset;\n    box-shadow: var(--mantine-shadow-outline);\n  }\n\n  &[data-variant='link'] {\n    height: fit-content;\n    background-color: transparent;\n    color: var(--text-link);\n    padding: 0px;\n    border-radius: unset;\n\n    &:active {\n      box-shadow: unset;\n    }\n\n    .buttonInner {\n      &:hover {\n        text-decoration: underline;\n        text-decoration-color: currentColor;\n      }\n    }\n  }\n\n  &[data-variant='light'] {\n    border-width: 1px;\n    border-color: var(--button-hover);\n  }\n\n  &[data-variant='transparent'] {\n    &:hover {\n      background-color: var(--background-hover);\n    }\n\n    &:active {\n      box-shadow: unset;\n    }\n  }\n\n  &[data-variant='active'] {\n    background-color: var(--background-accent);\n\n    .buttonInner {\n      color: var(--text-active);\n      --button-color: var(--text-active);\n    }\n\n    &:active {\n      background-color: var(--background-accent-secondary);\n      box-shadow: unset;\n    }\n  }\n}\n\n@mixin light-root {\n  .button {\n    &[data-variant='inverse'] {\n      --button-color: var(--mantine-color-gray-1);\n      color: var(--mantine-color-gray-1);\n      background-color: var(--mantine-color-gray-9);\n\n      &:disabled {\n        background-color: var(--mantine-color-gray-5);\n        --button-color: var(--mantine-color-gray-1);\n        color: var(--mantine-color-gray-1);\n        box-shadow: unset;\n      }\n\n      &[data-loading] {\n        --button-color: var(--mantine-color-gray-1);\n        color: var(--mantine-color-gray-1);\n        background-color: var(--mantine-color-gray-9);\n      }\n    }\n\n    &[data-variant='normal'] {\n      --button-color: var(--text-primary);\n      color: var(--text-primary);\n      background-color: var(--mantine-color-gray-0);\n      border-width: 1px;\n      border-color: var(--border-secondary);\n\n      &:disabled {\n        box-shadow: unset;\n        --button-color: var(--text-tertiary);\n        color: var(--text-tertiary);\n      }\n\n      &:hover {\n        background-color: var(--mantine-color-gray-1);\n      }\n    }\n  }\n}\n\n@mixin dark-root {\n  .button {\n    &[data-variant='inverse'] {\n      --button-color: var(--mantine-color-gray-9);\n      color: var(--mantine-color-gray-9);\n      background-color: var(--mantine-color-gray-1);\n\n      &:disabled {\n        background-color: var(--mantine-color-gray-6);\n        --button-color: var(--mantine-color-gray-9);\n        color: var(--mantine-color-gray-9);\n        box-shadow: unset;\n      }\n\n      &[data-loading] {\n        --button-color: var(--mantine-color-gray-9);\n        color: var(--mantine-color-gray-9);\n        background-color: var(--mantine-color-gray-1);\n      }\n    }\n\n    &[data-variant='normal'] {\n      --button-color: var(--text-primary);\n      color: var(--text-primary);\n      background-color: var(--mantine-color-gray-9);\n      border-width: 1px;\n      border-color: var(--border-secondary);\n\n      &:disabled {\n        box-shadow: unset;\n        --button-color: var(--text-tertiary);\n        color: var(--text-tertiary);\n      }\n\n      &:hover {\n        background-color: var(--background-hover);\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `nightbot-button-module__button-FTSYP`,
	"buttonInner": `nightbot-button-module__buttonInner-CNbjx`,
	"buttonLoader": `nightbot-button-module__buttonLoader-MxCrP`
};
export default ___CSS_LOADER_EXPORT___;
